import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../Context/DataContext';
import PageHeader from '../../components/PageHeader/PageHeader';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Button from '../../components/Button/Button';
import styles from './Approvals.module.css';

const Approvals = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const { studiesData } = useData();

  const tabs = [
    { id: 'pending', label: 'Pending', count: studiesData.pending.length },
    { id: 'changes', label: 'Changes requested', count: studiesData.changes.length },
    { id: 'approved', label: 'Approved this week', count: 26 },
    { id: 'rejected', label: 'Rejected', count: studiesData.rejected.length }
  ];

  const currentList = studiesData[activeTab] || studiesData.pending;

  const headerActions = (
    <Link to="/settings">
      <Button variant="secondary">Approval rules</Button>
    </Link>
  );

  return (
    <>
      <PageHeader
        title="Study approvals"
        subtitle="Every study is checked before participants can see it."
        actions={headerActions}
      />

      <FilterTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Study</div>
          <div>Researcher</div>
          <div>Submitted</div>
          <div>Incentive</div>
          <div>Seats</div>
          <div>Auto-check</div>
          <div></div>
        </div>

        {currentList.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <div>
              <div className={styles.studyInfo}>
                <span className={styles.studyTitle}>{item.title}</span>
                <span className={styles.studyType}>{item.type}</span>
              </div>
            </div>

            <div className={styles.researcherText}>{item.researcher}</div>
            <div className={styles.submittedText}>{item.submitted}</div>
            <div className={styles.incentiveText}>{item.incentive}</div>
            <div className={styles.seatsText}>{item.seats}</div>

            <div>
              <span
                className={styles.checkBadge}
                style={{ color: item.check.color, background: item.check.bg }}
              >
                {item.check.label}
              </span>
            </div>

            <div>
              <Link to="/study-review" className={styles.reviewLink}>
                Review →
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Approvals;
